import {
  csx,
  IconArchive,
  IconCopySimple,
  Menu,
  MenuButton,
  MenuItem,
  useMenuState,
} from '@vtex/admin-ui'
import React from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { useNavigation } from '@vtex/raccoon-next'
import { Event, type ColumnParams, type GenericPromotion } from 'typings'
import { useAnalytics } from 'use-analytics'
import { usePromotionState } from './promotionState'

const messages = defineMessages({
  unarchive: { id: 'admin/promotions.list.actions.unarchive' },
  duplicate: { id: 'admin/promotions.list.actions.duplicate' },
})

export function ArchivedActionsButton(props: ColumnParams<GenericPromotion>) {
  const {
    item: { id, type },
  } = props

  const { formatMessage } = useIntl()
  const { track } = useAnalytics()
  const { navigate } = useNavigation()
  const { unarchive } = usePromotionState()

  const menuState = useMenuState()

  return (
    <>
      <MenuButton
        state={menuState}
        variant="neutralTertiary"
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          event.stopPropagation()
        }
        className={csx({ float: 'right' })}
        labelHidden
      />
      <Menu state={menuState}>
        <MenuItem
          icon={<IconArchive />}
          label={formatMessage(messages.unarchive)}
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation()
            unarchive(id)
          }}
        />

        <MenuItem
          icon={<IconCopySimple />}
          label={formatMessage(messages.duplicate)}
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation()

            track(Event.DUPLICATED_PROMOTION, {
              type,
              archived: true,
            })

            navigate(`/new?duplicate=${id}&type=${type}`)
          }}
        />
      </Menu>
    </>
  )
}
